import { compose } from 'recompose';
import ButtonText from './buttonText';

const enhance = compose();
export default enhance(ButtonText);
